import { includes, values, last } from 'lodash';
import { CHART_CHANNEL_ENUM } from 'constants/chart-channels';
import {
  ARRAY_NUMERIC_REDUCTIONS,
  REDUCTION_AXIS_TITLE_FACTORIES,
} from 'constants/reductions';

// whitelist axes from CHART_CHANNEL_ENUM (as opposed to chart legends)
const CHART_AXES = [
  CHART_CHANNEL_ENUM.X,
  CHART_CHANNEL_ENUM.Y,
  CHART_CHANNEL_ENUM.X2,
  CHART_CHANNEL_ENUM.Y2,
];

/**
 * Generate axis labels based on the types of every element in the provided
 * channel reduction array
 *
 * @param {Object} channel           the encoding channel object of the channel
 * @param {Object} channelReductions  the reductions object of the channel
 * @return {String}                   human readable string representation of reductions
 */
export function generateReductionAxisLabel(channel, channelReductions) {
  // generate array of strings based on reduction type and join them
  const reductionLabel = channelReductions
    .map(reduction =>
      reduction.type && reduction.arguments
        ? REDUCTION_AXIS_TITLE_FACTORIES[reduction.type](reduction.arguments)
        : ''
    )
    .join('');
  const lastReduction = last(channelReductions);

  // add 'numeric array' prefix if the final reduction type is for numeric types
  let arrayLabel = includes(
    values(ARRAY_NUMERIC_REDUCTIONS),
    lastReduction.type
  )
    ? 'numeric array '
    : 'array ';

  arrayLabel += `'${channel.field}'`;

  return reductionLabel + arrayLabel;
}

export function generateChannelLabel(channel, channelName, reductions) {
  // add titles to all channels
  let title =
    reductions[channelName] && includes(CHART_AXES, channelName)
      ? generateReductionAxisLabel(channel, reductions[channelName])
      : channel.field;
  if (channel.aggregate) {
    title = `${channel.aggregate} ( ${title} )`;
  }
  return title;
}
